import { FormattedMessage } from 'react-intl';
import EmptyState from '@rio-cloud/rio-uikit/EmptyState';

interface FilteredEmptyProps {
    onCreateDriver: () => void;
}

export const FilteredEmpty = ({ onCreateDriver }: FilteredEmptyProps) => (
    <div className={'display-flex justify-content-center'}>
        <EmptyState
            headline={<FormattedMessage id={'intl-msg:no.drivers'} />}
            message={<FormattedMessage id={'intl-msg:no.drivers.message'} />}
            buttons={[
                {
                    onClick: onCreateDriver,
                    text: <FormattedMessage id={'intl-msg:createDriver.addDriver.button'} />,
                },
            ]}
        />
    </div>
);
